<template>
  <section id="tour">
    <div id="columns">
      <div>
        <div id="poster-wrap">
          <div id="poster-stack">
            <img
              class="poster-card overlay-card"
              :class="positionClass('corona-capital')"
              :src="coronaCapitalPoster"
              alt="Good Kid Corona Capital Tour Poster"
              @click="frontPoster = 'corona-capital'"
            />
            <img
              class="poster-card layout-card"
              :class="positionClass('japan')"
              :src="japanPoster"
              alt="Good Kid Japan Tour Poster"
              @click="frontPoster = 'japan'"
            />
          </div>
        </div>
      </div>
      <div id="tour-dates">
        <div id="tour-dates-inner">
          <iframe id="laylo-drop-11697e72-3265-4ab9-9821-92a43397bd86" frameborder="0" scrolling="no" allow="web-share encrypted-media *;"
            allowtransparency="true" style="width: 1px; min-width: 100%; max-width: 1000px"
            src="https://embed.laylo.com?dropId=11697e72-3265-4ab9-9821-92a43397bd86&color=b6bdce&minimal=true&theme=light">
          </iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import coronaCapitalPoster from "@/assets/tour/2026/corona-capital-poster.jpg";
import japanPoster from "@/assets/tour/2026/japan-poster.jpg";

export default {
  name: "TourSection",
  data() {
    return {
      frontPoster: "japan",
      coronaCapitalPoster,
      japanPoster,
    };
  },
  methods: {
    positionClass(poster) {
      return this.frontPoster === poster ? "is-front" : "is-back";
    },
  },
};
</script>

<style scoped>
#tour {
  padding: 0% 5% 5% 5%;
}

#columns {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 40px;
}

#poster-wrap {
  margin-top: 35px;
  position: sticky;
  top: 50px;
  width: 90%;
}

#poster-stack {
  position: relative;
  width: 100%;
}

.poster-card {
  width: 100%;
  height: auto;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
  cursor: pointer;
  transform-origin: 50% 60%;
  transition:
    transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1),
    filter 0.55s ease;
  will-change: transform;
}

.layout-card {
  position: relative;
  display: block;
}

.overlay-card {
  position: absolute;
  top: 0;
  left: 0;
}

.poster-card.is-front {
  z-index: 2;
  transform: rotate(0deg) translate(0, 0);
  filter: drop-shadow(2px 6px 8px rgba(0, 0, 0, 0.28));
}

.poster-card.is-back {
  z-index: 1;
  transform: rotate(7deg) translate(7%, 3%);
  filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.18));
}

.poster-card.is-back:hover {
  transform: rotate(9deg) translate(9%, 2%);
}

.poster-card.is-front {
  cursor: default;
}

#callout {
  background: linear-gradient(135deg, #c221cdbd 0%, #8b17a070 100%);
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(194, 33, 205, 0.3);
}

#callout p {
  margin: 0;
  color: #fff;
  font-size: 1.1rem;
  line-height: 1.5;
  text-align: center;
}

#call-to-action {
  margin-top: 10px !important;
}

#callout strong {
  display: block;
  font-size: 1.2rem;
  margin-bottom: 4px;
}

#tour-dates-inner {
  background-color: #c221cd26;
  border-radius: 24px;
  padding: 0 12px;
}

@media screen and (max-width: 999px) {
  #columns {
    grid-template-columns: 1fr;
  }

  #poster-wrap {
    display: none;
  }
}
</style>
